const projectsteps = {
        stepswithoutENG: [
            {
                target: '.v-step-0',
                content: 'Click to see the latest updates. When a new update is available, this button will be red.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-1',
                content: 'Click to edit the list of shared users.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-2',
                content: 'Click to change the language.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-3',
                content: `Click to create a new project.`,
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-4',
                content: 'Enter text here to filter the project list.',
                params: {
                    placement: 'left'
                }
            }
        ],
        stepswithENG: [
            {
                target: '.v-step-0',
                content: 'Click to see the latest updates. When a new update is available, this button will be red.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-1',
                content: 'Click to edit the list of shared users.',
                params: {
                    placement: 'bottom'
                }
            },
                {
                target: '.v-step-2',
                content: 'Click to change the language.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-3',
                content: `Click to create a new project.`,
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-4',
                content: 'Enter text here to filter the project list.',
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-5',
                content: 'This is the number of windows in a project.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-6',
                content: 'Click to generate a .CSV file with the BOM for the complete project. The .CSV file is stored in your Downloads folder.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-7',
                content: 'Click to generate a .PDF file with the mounting instructions for all windows in this project. The .PDF file is stored in your Downloads folder.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-8',
                content: 'Click to show the list of windows in a project.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-9',
                content: 'Click to select the users that will share this project.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-10',
                content: 'Click to edit the project data.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-11',
                content: 'Click to make a copy of a project including all windows.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-12',
                content: 'Click to delete a project.',
                params: {
                    placement: 'top'
                }
            }
        ],
        stepswithoutNED: [
            {
                target: '.v-step-0',
                content: 'Klik om de laatste updates te bekijken. Deze knop kleurt rood wanneer een nieuwe update beschikbaar is.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-1',
                content: `Klik om de lijst van gedeelde gebruikers te bekijken of aan te passen`,
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-2',
                content: `Klik om de taal te kiezen.`,
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-3',
                content: `Klik om een nieuw project aan te maken.`,
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-4',
                content: 'Typ tekst in deze balk om de projectlijst te filteren.',
                params: {
                    placement: 'left'
                }
            }
        ],
        stepswithNED: [
            {
                target: '.v-step-0',
                content: 'Klik om de laatste updates te bekijken. Deze knop kleurt rood wanneer een nieuwe update beschikbaar is.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-1',
                content: `Klik om de lijst van gedeelde gebruikers te bekijken of aan te passen`,
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-2',
                content: `Klik om de taal te kiezen.`,
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-3',
                content: `Klik om een nieuw project aan te maken.`,
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-4',
                content: 'Typ tekst in deze balk om de projectlijst te filteren.',
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-5',
                content: 'Dit is het aantal ramen in een project. Als een project gedeeld wordt dan wordt dit hier aangeduid.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-6',
                content: 'Klik om een .CSV bestand te genereren met de BOM voor het hele project. Het .CSV bestand wordt in uw Downloads folder bewaard.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-7',
                content: 'Klik om een gebundeld .PDF bestand aan te maken met de montage instructies voor alle ramen in een project. Het .PDF bestand wordt in uw Downloads folder bewaard.',
                params: {
                    placement: 'top'
                }
            },
                {
                target: '.v-step-8',
                content: 'Klik om de ramenlijst van een project te tonen.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-9',
                content: 'Klik om gebruikers te selecteren die dit project delen.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-10',
                content: 'Klik om de projectgegevens te wijzigen.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-11',
                content: 'Klik om een kopie te maken van een project incl. alle ramen.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-12',
                content: 'Klik om een project te verwijderen.',
                params: {
                    placement: 'top'
                }
            }
        ],
        stepswithoutCHI: [
            {
                target: '.v-step-0',
                content: '单击此按钮可查看最新升级。当软件有新的升级时，此按钮为红色。',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-1',
                content: `点击编辑共享用户列表`,
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-2',
                content: '点击更改语言',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-3',
                content: `单击此按钮创建新的项目`,
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-4',
                content: '在此输入文本可筛选项目列表',
                params: {
                    placement: 'left'
                }
            }
        ],
        stepswithCHI: [
            {
                target: '.v-step-0',
                content: '单击此按钮可查看最新升级。当软件有新的升级时，此按钮为红色。',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-1',
                content: `点击编辑共享用户列表`,
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-2',
                content: '点击更改语言',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-3',
                content: `单击此按钮创建新的项目`,
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-4',
                content: '在此输入文本可筛选项目列表',
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-5',
                content: '项目中窗型的数量',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-6',
                content: '单击此按钮生成一个.CSV文件，其中包含完整项目的物料清单。.CSV文件存储在下载文件夹中。',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-7',
                content: '单击此按钮生成一个 .PDF文件，其中包含此项目中所有窗型的安装说明。.PDF文件存储在下载文件夹中',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-8',
                content: '单击此按钮显示项目中的窗型列表',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-9',
                content: '点击选择用户，将此项目共享给该用户',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-10',
                content: '单击此按钮可编辑项目参数',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-11',
                content: '单击此按钮可复制项目全部窗型',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-12',
                content: '单击此按钮可删除项目',
                params: {
                    placement: 'top'
                }
            }
        ],
        stepswithoutPOR: [
            {
                target: '.v-step-0',
                content: 'Carregue para ver as últimas atualizações. Quando uma nova atualização é colocada, este botão fica vermelho.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-1',
                content: '– Carregue para editar a listagem de utilizadores partilhados.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-2',
                content: 'Carregue para alterar o idioma.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-3',
                content: `Carregue para criar um novo projeto.`,
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-4',
                content: 'Insira o texto a pesquisar na lista de projetos.',
                params: {
                    placement: 'left'
                }
            }
        ],
        stepswithPOR: [
            {
                target: '.v-step-0',
                content: 'Carregue para ver as últimas atualizações. Quando uma nova atualização é colocada, este botão fica vermelho.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-1',
                content: 'Carregue para editar a listagem de utilizadores partilhados.',
                params: {
                    placement: 'bottom'
                }
            },
                {
                target: '.v-step-2',
                content: 'Carregue para alterar o idioma.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-3',
                content: `Carregue para criar um novo projeto.`,
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-4',
                content: 'Insira o texto a pesquisar na lista de projetos.',
                params: {
                    placement: 'left'
                }
            },
            {
                target: '.v-step-5',
                content: 'Número de janelas configuradas no projeto.',
                params: {
                    placement: 'bottom'
                }
            },
            {
                target: '.v-step-6',
                content: 'Carregue para gerar um ficheiro .CSV com a BOM da totalidade do projeto. O ficheiro .CSV será guardado na pasta de Transferências.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-7',
                content: 'Carregue para gerar um ficheiro .PDF com as instruções de montagem para todas as janelas do projeto. O ficheiro .PDF será guardado na pasta de Transferências.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-8',
                content: 'Carregue para ver a listagem de janelas do projeto.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-9',
                content: 'Carregue para selecionar os utilizadores que irão partilhar este projeto.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-10',
                content: 'Carregue para editar as características de um projeto.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-11',
                content: 'Carregue para criar uma cópia de um projeto com a totalidade das janelas.',
                params: {
                    placement: 'top'
                }
            },
            {
                target: '.v-step-12',
                content: 'Carregue para eliminar um projeto.',
                params: {
                    placement: 'top'
                }
            }
        ],
    }

    export default projectsteps


// WEBPACK FOOTER //
// ./src/ClientApp/helpers/project-steps.js